import React, { useState, useEffect } from 'react';

const GOOGLE_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwxZNqqgtkQJRZNGYzhWH9Kw6fIvUyvPcqZe3dTUgcJ7cV22OrJ1w78Fxo-owDS-bYi/exec";

// Add `onSkip` and `onFormSubmit` to the props
const ContactFormModal = ({ isOpen, onClose, product, onSkip, onFormSubmit }) => {
  const [formData, setFormData] = useState({ name: '', email: '', company: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  useEffect(() => {
    if (isOpen) {
      setFormData({ name: '', email: '', company: '', message: '' });
      setIsSubmitting(false);
      setSubmitMessage('');
    }
  }, [isOpen]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);
    setSubmitMessage('Submitting...');

    const payload = { ...formData, productName: product.title };

    try {
      await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      setSubmitMessage('Success! Your download will begin shortly.');
      
      // *** CHANGE: Instead of downloading here, tell the parent to do it. ***
      onFormSubmit(product);

      setTimeout(() => {
        onClose();
      }, 2000);

    } catch (error) {
      console.error("Error submitting form:", error);
      setSubmitMessage('An error occurred. Please try again.');
      setIsSubmitting(false);
    }
  };
  
  // *** NEW: Handler for the skip button ***
  const handleSkipClick = () => {
    onSkip(product); // Notify the parent to trigger the direct download
    onClose();       // Immediately close the modal
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="modal-close-btn">&times;</button>
        <h2>Download Specs for <span className="product-title">{product.title}</span></h2>
        <p>Please provide your details to start the download.</p>

        <form onSubmit={handleSubmit} className="modal-form">
          <input type="text" name="name" placeholder="Full Name" onChange={handleInputChange} value={formData.name} required />
          <input type="email" name="email" placeholder="Work Email" onChange={handleInputChange} value={formData.email} required />
          <input type="text" name="company" placeholder="Company Name" onChange={handleInputChange} value={formData.company} />
          <textarea name="message" placeholder="Message (Optional)" onChange={handleInputChange} value={formData.message} rows="3"></textarea>
          <button type="submit" disabled={isSubmitting} className="modal-form-submit-btn">
            {isSubmitting ? 'Processing...' : 'Submit & Download'}
          </button>
          {submitMessage && <p className="submit-message">{submitMessage}</p>}
        </form>
        
        {/* *** NEW: The skip button/link container *** */}
        <div className="skip-container">
            <button type="button" className="skip-button" onClick={handleSkipClick}>
                or skip and download directly
            </button>
        </div>
      </div>
    </div>
  );
};

export default ContactFormModal;